import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Table from "../Table";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
function OrigenDatos(props) {
  const { history } = props;
  const [OrigenDatosStateUpdate, setOrigenDatosStateUpdate] = useState([]);
  const [OrigenDatosState, setOrigenDatosState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "origins/?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setOrigenDatosState(JSON.parse(responseJsonUpdate));
        setOrigenDatosStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, usuario, history]);
  const [formularioState, setFormularioState] = useState({
    description: "",
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };
  let crearOrigenDatos = async (event) => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      event.preventDefault();
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "origins/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          document.getElementById("formularioBusqueda").reset();
          setUpdate(!update);
          alert(responseJson.message);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };
  let OrigenDatosHandleChange = (index, e) => {
    let newList = OrigenDatosState;
    newList[index][e.target.name] = e.target.value;
    setOrigenDatosState(JSON.parse(JSON.stringify(newList)));
  };
  let confirmarEdicion = async (item) => {
    // setetapaStateUpdate(nuevoObjeto)
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let newForm = {};
        newForm.description = item.description;
        let response = await fetch(
          Parametros.urlApi + "origins/" + item.origin_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(item),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setEditable({});
          alert(responseJson.message);
          // setOrigenDatosState(JSON.parse(JSON.stringify(OrigenDatosState)))
          // setOrigenDatosStateUpdate(JSON.parse(JSON.stringify(OrigenDatosState)))
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setOrigenDatosState(
            JSON.parse(JSON.stringify(OrigenDatosStateUpdate))
          );
          setEditable({});
        }
      } else {
        // Do nothing!
        setEditable({});
        setOrigenDatosState(JSON.parse(JSON.stringify(OrigenDatosStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setOrigenDatosState(JSON.parse(JSON.stringify(OrigenDatosStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setOrigenDatosState(JSON.parse(JSON.stringify(OrigenDatosStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Origen de datos"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearOrigenDatos}>
          <div className="col-md-4">
            <h5>Nombre Origen de Dato</h5>
            <input
              onChange={handleStageForm}
              name="description"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="button"
              onClick={(e) => {
                crearOrigenDatos(e);
              }}
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(OrigenDatosState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Nombre"]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Nombre"]}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {OrigenDatosState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.origin_id}>
                      {editable === item.origin_id ? (
                        <>
                          <td>{item.origin_id}</td>
                          <td>
                            <input
                              value={item.description}
                              name="description"
                              onChange={(event) => {
                                OrigenDatosHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.origin_id}</td>
                          <td>{item.description} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.origin_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`origins/${item.origin_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(OrigenDatosState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(OrigenDatos);
